import { Formik } from 'formik'
import { ReactElement, useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button } from 'components/v2/Button'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import FormLayoutV2 from 'components/v2/FormLayout'
import { ItinerariesCard } from 'features/Services/components/NewServicesV2/components/ItinerariesCard'
import { IItineraryFormProps } from 'features/Routes/components/EditRoute/ItineraryForm/types'
import { ServicesSelector } from 'features/Services/components/NewServicesV2/components/ServicesSelector'
import { servicesFormSchema } from './schema'
import { GTRouteServiceItineraryScheduleStatus } from 'gql/types.generated'
import { isDate } from 'date-fns'

export const ItineraryForm = ({
  services = [],
  onSubmit,
  onCancel,
  error,
  loading,
  scrollToTop
}: IItineraryFormProps): ReactElement => {
  const intl = useIntl()
  const [currentServiceIndex, setCurrentServiceIndex] = useState<number>(0)
  useEffect(() => {
    scrollToTop?.()
  }, [])

  const initialValues = {
    services
  }

  return (
    <Formik initialValues={initialValues} validationSchema={servicesFormSchema(intl)} onSubmit={onSubmit}>
      {({ handleSubmit, values }): ReactElement => {
        const currentService = values.services[currentServiceIndex]
        const isEndDateOptional = !isDate(currentService.endDate)
        return (
          <FormLayoutV2.Content as="form" onSubmit={handleSubmit} isLargeContent>
            <ServicesSelector
              currentServiceIndex={currentServiceIndex}
              setCurrentServiceIndex={setCurrentServiceIndex}
              readOnly
            />
            <FormLayoutV2.Divider />
            <ItinerariesCard
              currentServiceIndex={currentServiceIndex}
              shownItineraries={
                currentService.oldItineraries?.filter(
                  ({ status }) => status === GTRouteServiceItineraryScheduleStatus.Enabled
                ) || []
              }
              title={
                <FormattedMessage id="routes.edit.itineraries.previous.title" defaultMessage="Previous Itineraries" />
              }
              disabled
              isEndDateOptional={isEndDateOptional}
            />
            <ItinerariesCard
              currentServiceIndex={currentServiceIndex}
              shownItineraries={currentService.itineraries}
              title={<FormattedMessage id="routes.edit.itineraries.new.title" defaultMessage="New Itineraries" />}
              isEndDateOptional={isEndDateOptional}
            />
            {!!error && (
              <FormLayoutV2.Actions>
                <ErrorMessage>{error}</ErrorMessage>
              </FormLayoutV2.Actions>
            )}
            <FormLayoutV2.Actions>
              <Button type="button" kind="cancel" onClick={onCancel}>
                <FormattedMessage id="dictionary.cancel" defaultMessage="Cancel" />
              </Button>
              <Button type="submit" kind="primary" loading={loading}>
                <FormattedMessage id="dictionary.save" defaultMessage="Save" />
              </Button>
            </FormLayoutV2.Actions>
          </FormLayoutV2.Content>
        )
      }}
    </Formik>
  )
}
